// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_svg_relief_transform/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_svg_relief_transform: ModuleSchema = {
  "id": "core_svg_relief_transform",
  "uniqueId": "B3D_RLF01",
  "createdAt": "2026-10-11T05:00:00Z",
  "updatedAt": "2026-10-11T09:57:51.694Z",
  "label": "Relief Transform Probe",
  "description": "Standalone core geometry module for relief in-plane transform and surface placement (CG_RLF01)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_RLF01",
    "relief-transform",
    "svg-placement"
  ],
  "sliders": [
    {
      "key": "scale",
      "label": "Relief Face Scale",
      "min": 0.4,
      "max": 3,
      "default": 1,
      "step": 0.1,
      "unit": "",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "thickness",
      "label": "Emboss Thickness (mm)",
      "min": 0.2,
      "max": 3,
      "default": 0.6,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "rotateDeg",
      "label": "Face Rotation (deg)",
      "min": -180,
      "max": 180,
      "default": 0,
      "step": 5,
      "unit": "°",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "offsetX",
      "label": "Offset X (mm)",
      "min": -25,
      "max": 25,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "offsetZ",
      "label": "Offset Z (mm)",
      "min": -25,
      "max": 25,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base",
      "label": "Substrate Plate Color",
      "default": "#64748B",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "relief",
      "label": "Placed Relief Color",
      "default": "#3B82F6",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "base_plate",
      "name": "Substrate Surface Plate",
      "parts": [
        {
          "id": "base_part",
          "name": "Base Plate",
          "groupId": 0,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    },
    {
      "id": "placed_relief",
      "name": "Placed Relief Solid",
      "parts": [
        {
          "id": "relief_part",
          "name": "Transformed Relief",
          "groupId": 1,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    },
    {
      "id": "0",
      "label": "Download STL - Base Plate"
    },
    {
      "id": "1",
      "label": "Download STL - Placed Relief"
    }
  ]
};
